import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { MultiStepForm } from '../../components';
import { useCurrentUser } from '../../shared/currentUser';
import { Steps } from 'react-step-builder';
import {
  BulkDownloadDocumentsDateSelection,
  BulkDownloadDocumentsDocsSelection,
  BulkDownloadDocumentsIncludeStakeholders,
  BulkDownloadDocumentsInsuredsSelection,
  BulkDownloadDocumentsEmailConfirmation
} from './components/';
import { useBulkDownloadDocumentsFormSteps } from './hooks';
import { useBulkDownloadDocumentsJobContext } from '../../context';
import { SERVER_SIDE_DATE_FORMAT } from '../../utils/dates';

export default function BulkDownloadDocuments({ policyId, clientId, redirectUrl, initialState }) {
  const history = useHistory();
  const currentUser = useCurrentUser();
  const { enqueueBulkDownloadDocuments, loading, error } = useBulkDownloadDocumentsJobContext();
  const isClientContext = !!clientId;
  const { loading: initialLoading, error: initialError, allData } = initialState;

  const { formSteps } = useBulkDownloadDocumentsFormSteps(initialState);

  const onSubmit = values => {
    const { activeOn, includeStakeholders, documentIds, insuredIds } = values;

    const filteredForDocuments = allData.filter(x => documentIds.includes(x.documentId));
    const filteredForInsureds = filteredForDocuments.filter(x => insuredIds.includes(x.insuredId));
    const documentRelationshipIds = filteredForInsureds.map(x => x.documentRelationshipId);

    enqueueBulkDownloadDocuments({
      activeOn: activeOn === '' ? null : moment(activeOn).format(SERVER_SIDE_DATE_FORMAT),
      clientId: isClientContext ? clientId : null,
      policyId: isClientContext ? null : policyId,
      documentRelationshipIds,
      includeStakeholders,
      redirectUrl
    });
  };

  return (
    <MultiStepForm
      formSteps={formSteps}
      formSubmit={onSubmit}
      maxWidth={'800px'}
      title={`Bulk Download Documents`}
      onCancel={() => history.push(redirectUrl)}
      submitButtonText={'Confirm & Send to Email'}
      submitButtonProps={{ disabled: !currentUser?.email, loading, loadingText: 'Submitting...' }}
      showButtonsOnBottom
      loading={initialLoading}
      error={initialError || error}
    >
      {formProps => (
        <Steps>
          <BulkDownloadDocumentsDateSelection {...formProps} />
          <BulkDownloadDocumentsIncludeStakeholders {...formProps} />
          <BulkDownloadDocumentsDocsSelection clientId={clientId} policyId={policyId} {...formProps} />
          <BulkDownloadDocumentsInsuredsSelection clientId={clientId} policyId={policyId} {...formProps} />
          <BulkDownloadDocumentsEmailConfirmation {...formProps} />
        </Steps>
      )}
    </MultiStepForm>
  );
}
